import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

/* Models */
import characterModel from '../models/character.model';

/* Components */ 
import UC from './uc';
import Gerald from './gerald';
import Susie from './susie';
import Astro from './astro';
import Wakanda from './wakanda';
import Tiana from './tiana';
import Fillmore from './fillmore';
import UserManagement from './userManagement';

import NotificationCenter from "../shared/notifications";

/* Images */
import geraldSilo from '../../assets/silo/gerald.png';
import astroSilo from '../../assets/silo/astro.png';
import wakandaSilo from '../../assets/silo/wakanda.png';
import tianaSilo from '../../assets/silo/tiana.png';
import fillmoreSilo from '../../assets/silo/fillmore.png';
import susieSilo from '../../assets/silo/susie.png';

class Base extends Component{
    constructor(props) {
        super(props);
        this.state = {
            admin:false,
            selectedChar: "gerald",
            toggleMenu: false, toggleNotifications: false,
            notificationList:[], activeNotiCt:0
        }

        this.characterList = {
            "gerald": new characterModel("gerald", "Gerald", true, false, geraldSilo, <Gerald checkUser={this.props.checkUser} getInit={this.props.getInit} setInit={this.props.setInit}/>),
            "susie": new characterModel("susie", "Susie", true, true, susieSilo, <Susie baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            "astro": new characterModel("astro", "Astro", true, true, astroSilo, <Astro baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            "wakanda": new characterModel("wakanda", "Wakanda", true, false, wakandaSilo, <Wakanda baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            "tiana": new characterModel("tiana", "Tiana", true, false, tianaSilo, <Tiana baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            "fillmore": new characterModel("fillmore", "Fillmore", true, false, fillmoreSilo, <Fillmore baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            // Non-Active Nav
            "usermng": new characterModel("usermng", "Users", false, false, null, <UserManagement baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} />),
            "uc": new characterModel("uc", "Under Construction", false, false, null, <UC checkUser={this.props.checkUser} />)
        }

        // References
        this.notifyRef = React.createRef();

        // Functions
        this.changeSelectedChar = this.changeSelectedChar.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleNotifications = this.toggleNotifications.bind(this);
        this.updateNotificationList = this.updateNotificationList.bind(this);
    }

    renderSwitch(param) {
        try {
            let tmpChar = (param !== null ? this.characterList[param.toLowerCase()]: null);
            return (!tmpChar ? this.characterList.uc.bodyComponent : tmpChar.bodyComponent );
        }
        catch(ex){
            console.log("[Error] Rendering Switch: ",ex);
        }
    }

    changeSelectedChar(newChar){
        try {
            this.setState({ selectedChar: newChar.toLowerCase(), toggleMenu: false });                    
        }
        catch(ex){
            console.log(" [Error] changing selected character: ",ex);
        }        
    }

    toggleMenu(){
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    toggleNotifications(){
        if(!this.state.toggleNotifications === false){
            this.notifyRef.current.toggleSettings(false);
        }
        this.setState({ toggleNotifications: !this.state.toggleNotifications })
    }

    updateNotificationList(list){
        try {
            var activeCt = list.filter(function(item){ return item.dismissed == undefined || !item.dismissed; }).length;
            
            this.setState({ notificationList: list, activeNotiCt: activeCt });
        }   
        catch(ex){
            console.log("[Error] Updating Notification List: ",ex);
        } 
    }

    componentDidMount(){ 
        var tmpUser = this.props.checkUser(false,true);
        if(tmpUser){
            this.setState({ admin: tmpUser.admin });
        }
    }

    render(){   
        var charList = Object.values(this.characterList).filter(function(item) { return item.navActive === true; }); 

        return(
            <div className={"page-body " + this.state.selectedChar }>
                <NotificationCenter ref={this.notifyRef} display={this.state.toggleNotifications} toggleNotification={(status) => this.setState({ toggleNotifications: status })} updateNotificationList={this.updateNotificationList} checkUser={this.props.checkUser} />
                {/* Page Silo*/}
                <TransitionGroup className="backimg-transition">
                    <CSSTransition key={this.state.selectedChar} timeout={1000} classNames="fade">
                        {this.characterList[this.state.selectedChar] && <img className="backimg" alt="character background" src={(this.characterList[this.state.selectedChar].silohette ? this.characterList[this.state.selectedChar].silohette : geraldSilo)} />}
                    </CSSTransition>
                </TransitionGroup>

                {/* Body */}
                <TransitionGroup className="page-transition">
                    <CSSTransition key={this.state.selectedChar} timeout={1000} classNames="pageslide">
                        <div className="content-body">
                            <div className={"content-nav" + (this.state.toggleMenu ? "":" closed")}>
                                {charList.map((item, i) =>                                    
                                        <div className={"nav-btn " + item.name + (this.state.selectedChar === item.name.toLowerCase() ? " selected" : "") + ((this.state.admin || !item.adminAccess) ? "" : " disabled")} key={i} onClick={() => this.changeSelectedChar(item.name)}>
                                            <div className="pt" /><span>{item.displayName}</span>
                                        </div>                                    
                                )}
                                
                                {this.state.admin &&
                                    <div className="nav-btn out" onClick={()=> this.changeSelectedChar("usermng")}>
                                        <i className="fas fa-cogs"/><span>Users</span>
                                    </div>
                                }
                                <div className={"nav-btn" + (!this.state.admin ? " out":"")} onClick={() => this.props.userHandler(null,()=>{ this.props.history.push("/access"); })}>
                                    <i className="fas fa-user-lock"/><span>Bye</span>
                                </div>
                            </div>
                            <div className={"content-display"  + (this.state.toggleMenu ? " open":"")}>
                                <div className="toggle-container"> 
                                    <div className="toggle-nav-container">                                   
                                        <div className="menu toggle-btn" onClick={this.toggleMenu}>
                                            <div className={"menu-btn" + (this.state.toggleMenu ? " open":" closed")}/>
                                        </div>       
                                    </div>   

                                    <div className="toggle-nav-container">                                    
                                        <div className="menu toggle-btn notification" onClick={this.toggleNotifications}>
                                            <i className="far fa-bell" />
                                            {this.state.activeNotiCt > 0 && 
                                                <div className="noti-count">{this.state.activeNotiCt}</div>
                                            }
                                        </div>                                    
                                    </div>                          
                                </div>

                                {this.renderSwitch(this.state.selectedChar)}
                            </div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );
    }
}

export default withRouter(Base);